import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
// *******************toster****************************
import Select from "react-select";
import ModalSave from "../../common/ModelSave";
import Validation from "../../common/FormValidation";
import { CancelButton, SaveButton } from "../../common/Button";

import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import classNames from "classnames";
import { putData } from "../../../utils/api";
import Spinner from "react-bootstrap/Spinner";
library.add(fas);

const EditOffCanvance = (props) => {
  const { postData, getData, Select2Data, IMG_URL } = useContext(Context);

  const id = props.show;
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const GetEditData = async () => {
    const response = await getData(`/admin/vendor/spotlight/${id}`);
    // reset(response?.data);
    if (response?.success) {
    reset({
      ...response.data,
      start_date: response.data.start_date?.slice(0, 10),
      end_date: response.data.end_date?.slice(0, 10),
    });
  }
  };

  const GetAllCountry = async () => {
    const response = await getData("/common/masters/all-vendors");
    if (response?.success) {
      setCountries(await Select2Data(response?.data, "vendor_id"));
    }
  };
  const GetAllStates = async (id) => {
    const response = await getData(`/common/masters/all-spotlight-type`);
    if (response?.success) {
      setStates(await Select2Data(response?.data, "spotlight_type_id"));
    }
  };
  useEffect(() => {
    GetAllCountry();
    GetAllStates();
    GetEditData();
  }, []);

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    watch,
    getValues,
  } = useForm();

  const imageFile = watch("certificate");
  const [loader, setLoader] = useState(false);
  const onSubmit = async (data) => {
    try {
      setLoader(true);
      const DataToSend = new FormData();
      DataToSend.append("vendor_id", data?.vendor_id?.value);
      DataToSend.append("spotlight_type_id", data?.spotlight_type_id?.value);
      DataToSend.append("name", data?.name);
      // DataToSend.append("certificate", data?.certificate[0]);
      DataToSend.append("start_date", data?.start_date);
      DataToSend.append("end_date", data?.end_date);
      const response = await putData(
        `/admin/vendor/spotlight/${id}`,
        DataToSend,
      );

      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({ code: response?.code, message: response?.errors });
      }
      setLoader(false);
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Edit Vendor Spotlight
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            onSubmit={() => handleSubmit(onSubmit)}
            role="form"
            // className="stateclass"
          >
            <Row>
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="row justify-content-center mb-2">
                    <Form.Label>Vendor</Form.Label>

                    <Controller
                      name="vendor_id" // name of the field
                      {...register("vendor_id", {
                        required: "Select Vendor",
                      })}
                      control={control}
                      render={({ field }) => (
                        <Select
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors.vendor_id
                                ? "red"
                                : baseStyles,
                            }),
                          }}
                          {...field}
                          options={countries}
                          onChange={(selectedOption) => {
                            field.onChange(selectedOption.value); // Update Controller's value
                            GetAllStates(selectedOption.value);
                            setValue("vendor_id", selectedOption);
                            // setValue("state_id", null);
                          }}
                        />
                      )}
                    />

                    {errors.vendor_id && (
                      <span className="text-danger">
                        {errors.vendor_id.message}
                      </span>
                    )}
                  </Row>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="row justify-content-center mb-2">
                    <Form.Label>Spotlight Type</Form.Label>

                    <Controller
                      name="spotlight_type_id" // name of the field
                      {...register("spotlight_type_id", {
                        required: "Select Spotlight Type",
                      })}
                      control={control}
                      render={({ field }) => (
                        <Select
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors.spotlight_type_id
                                ? "red"
                                : baseStyles,
                            }),
                          }}
                          {...field}
                          options={states}
                        />
                      )}
                    />

                    {errors.spotlight_type_id && (
                      <span className="text-danger">
                        {errors.spotlight_type_id.message}
                      </span>
                    )}
                  </Row>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>Name</Form.Label>

                    <Form.Group>
                      <InputGroup>
                        <Form.Control
                          type="text"
                          name="name"
                          placeholder="Name"
                          className={classNames("", {
                            "is-invalid": errors?.name,
                          })}
                          {...register("name", {
                            required: "Name is required",
                            validate: (value) =>
                              value.length <= 200 ||
                              "Data must be 200 characters or less",
                          })}
                        />
                      </InputGroup>
                      {errors.name && (
                        <span className="text-danger">
                          {errors.name.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>Start Date</Form.Label>

                    <Form.Group>
                      <InputGroup>
                        <Form.Control
                          type="date"
                          name="start_date"
                          placeholder="Start Date"
                          min={new Date().toISOString().split("T")[0]}
                          className={classNames("", {
                            "is-invalid": errors?.start_date,
                          })}
                          {...register("start_date", {
                            required: "Start Date is required",
                          })}
                        />
                      </InputGroup>
                      {errors.start_date && (
                        <span className="text-danger">
                          {errors.start_date.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>End Date</Form.Label>

                    <Form.Group>
                      <InputGroup>
                        <Form.Control
                          type="date"
                          name="end_date"
                          placeholder="End Date"
                          className={classNames("", {
                            "is-invalid": errors?.end_date,
                          })}
                          {...register("end_date", {
                            required: "End Date is required",
                          })}
                        />
                      </InputGroup>
                      {errors.end_date && (
                        <span className="text-danger">
                          {errors.end_date.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>

            {/*  <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-start">
                    <Form.Label className="text-left">Certificate</Form.Label>

                    <Form.Group>
                      <Form.Control
                        className={classNames("", {
                          "is-invalid": errors?.certificate,
                        })}
                        type="file"
                        {...register("certificate", {
                          // validate: async (value) => {
                          //   if (typeof value !== "string") {
                          //     const fileTypes = ["jpg", "png", "jpeg", "webp"];
                          //     const fileType = value[0].name?.split(".")[1];
                          //     if (!fileTypes.includes(fileType)) {
                          //       return `please upload a valid file format. (${fileTypes})`;
                          //     }
                          //     const sizes = await getDimension(value[0]);
                          //     if (
                          //       sizes.width !== 420 &&
                          //       sizes.height !== 520
                          //     ) {
                          //       return "Image width and height must be 420 px and 520 px";
                          //     }
                          //     const fileSize = Math.round(
                          //       value[0].size / 1024
                          //     );
                          //     if (fileSize > 500) {
                          //       return "file size must be lower than 500kb";
                          //     }
                          //   }
                          // },
                        })}
                        accept=".jpg, .jpeg, .png"
                      />
                    </Form.Group>
                    {errors.certificate && (
                      <span className="text-danger">
                        {errors.certificate.message}
                      </span>
                    )}
                  </Row>
                </div>
              </Col>

              <Col lg={6}>
                <div className="main-form-section mt-3">
                  <Form.Label>Certificate Preview</Form.Label>

                  {typeof getValues("certificate") == "string" ? (
                    <div className="image-preview-container">
                      <img
                        src={IMG_URL + getValues("certificate")}
                        alt="Preview"
                        className="image-preview"
                      />
                    </div>
                  ) : (
                    imageFile &&
                    imageFile?.length > 0 && (
                      <div className="image-preview-container">
                        <img
                          src={URL?.createObjectURL(imageFile[0])}
                          alt="Preview"
                          className="image-preview"
                        />
                      </div>
                    )
                  )}
                </div>
              </Col>*/}

              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton
                      name={"cancel"}
                      handleClose={props.handleClose}
                    />
                  </Link>
                  {loader ? (
                    <>
                      <Spinner animation="border" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </Spinner>
                    </>
                  ) : (
                    <>
                      <SaveButton
                        name={"save"}
                        handleSubmit={handleSubmit(onSubmit)}
                      />{" "}
                    </>
                  )}
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default EditOffCanvance;
